/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Preset_Manager_Import_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to import presets: {error}" |
*
* @param {Preset_Manager_Import_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_import_failed_toast = /** @type {((inputs: Preset_Manager_Import_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Import_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'importation des presets : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Voreinstellungen konnten nicht importiert werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile importare i preset: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось импортировать пресеты: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al importar ajustes preestablecidos: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导入预设失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プリセットのインポートに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रीसेट आयात करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao importar predefinições: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to import presets: ${i?.error}`)
});